import { EventMembershipTypes } from "@api/enums/EventMembershipTypes";
import { UserProfileInterface } from "@api/models/interfaces/UserProfileInterface";
import { UserProfile } from "@api/models/UserProfile";

export interface Progress {
    state: ProgressState;
    count: number;
    total?: number;
    reset: () => void;
}

export enum ProgressState {
    idle = 1,
    prepare,
    counting,
    completing,
    empty,
    import
}

export enum StepView {
    upload = 1,
    preview,
    import,
    result
}

export enum DuplicateAction {
    dontAdd = "dontAdd",
    update = "update",
    add = "add"
}

export interface UserProfileDuplicateInterface extends Pick<UserProfileInterface, 'firstName' | 'lastName' | 'company' | 'phoneNumber' | 'email'> {
    __rowNum__: string;
    action?: { id: DuplicateAction };
    role?: EventMembershipTypes | null;
    profile?: UserProfile;
    source?: ImportRowData;
}

export class UserProfileDuplicate implements UserProfileDuplicateInterface {
    __rowNum__: string;
    action?: { id: DuplicateAction };
    company?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    profile?: UserProfile;
    source?: ImportRowData;
    role?: EventMembershipTypes | null;

    constructor(data: UserProfileDuplicateInterface) {
        Object.assign(this, data)
    }
}

export type ImportRowData = Record<string, string | number>;

export interface ResultOfApplyingData {
    created: UserProfileInterface[];
    updated: UserProfileInterface[];
}

export interface AppliedDataCount {
    created: number;
    updated: number;
}